module.exports = __webpack_public_path__ + "media/images/cover/housing-d0b8738af32a3b878d7134300f7960d9.jpg";